import { useQuery } from '@tanstack/vue-query';
import { computed, type Ref } from 'vue';

import installationRiskApi from '~/services/installation-risk-api/installation-risk-api';

export default function usePartnerMigrationProjects(
  partnerId: Ref<number>,
  manufacturePlatform: Ref<string>,
  page: Ref<number>,
  pageSize: Ref<number>,
) {
  return useQuery({
    enabled: computed(() => !!partnerId.value && !!manufacturePlatform.value),
    queryFn: () =>
      installationRiskApi.getPartnerMigrationProjects({
        manufacture_platform: manufacturePlatform.value,
        page: page.value,
        pageSize: pageSize.value,
        partnerId: partnerId.value,
      }),
    queryKey: computed(() => [
      'partner-migration-projects',
      partnerId.value,
      manufacturePlatform.value,
      page.value,
      pageSize.value,
    ]),
  });
}
